 export default class PostFilter {
    constructor(options) {

       this.categories = options.categories || [];
       this.postType = options.postType || 'post';
       this.postsPerPage = options.postsPerPage || -1;
       this.ajaxObj = options.ajaxObj;
       this.ajaxMethod = options.ajaxMethod;
       this.categoryNotIn = options.categoryNotIn || [];
       this.post__in = options.post__in || [];

    }

    
    wpQueryArgs() {

       return {
          posts_per_page : this.postsPerPage,
          cat : this.categories,
          post_type : this.postType,
          category__not_in: this.categoryNotIn,
          post__in: this.post__in,
       };

    }

    setCats(cats) {
       

       var theCats = cats.map((x) => {
          return x.toString();
       }).toString();
       this.categories = [theCats];

    }

    resetCats() {
       this.categories = [];
    }

    setAjaxMethod(ajaxMethod) {
      this.ajaxMethod = ajaxMethod;
    }

    
    filter(beforeFilter, afterFilter) {

       if(beforeFilter) {
          beforeFilter();
       }

       let postFilter = this;

       $.ajax({
          type : 'GET',
          url  :  this.ajaxObj.ajax_url,
          data : {
            action     : postFilter.ajaxMethod,
            queryprops : postFilter.wpQueryArgs(),
          },
          success: function(data) {
             if(afterFilter) {
                afterFilter(data);
             }
          },
       });
    }

    setCatsAndFilter(cats, beforeFilter, afterFilter) {
       this.setCats(cats);
       this.filter(beforeFilter, afterFilter);
    }
 }


// WEBPACK FOOTER //
// ./scripts/classes/postFilter.js